// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreference.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {

  var React = require('react');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var MyProfileToolbar = require('../Toolbar/Izenda.MyProfileToolbar');
  var MyPreferenceId = require('./Izenda.MyPreferenceId');
  var MyPreferenceFirstName = require('./Izenda.MyPreferenceFirstName');
  var MyPreferenceLastName = require('./Izenda.MyPreferenceLastName');
  var MyPreferenceEmail = require('./Izenda.MyPreferenceEmail');
  var MyPreferenceRole = require('./Izenda.MyPreferenceRole');
  var MyPreferenceTimeZone = require('./Izenda.MyPreferenceTimezone');
  var MyPreferenceLanguageInfo = require('./Izenda.MyPreferenceLanguageInfo');

  var MyPreference = React.createClass({
    PropTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentDidMount: function() {
      var store = this.props.store;
      store.init();
      store.getMyProfile();
    },

    componentWillUnmount: function() {
      this.props.store.destroy();
    },

    render: function() {
      var store = this.props.store;
      if (store.model.isUserProfileHidden)
        return null;
      return (
        <div className='izenda-Wrapper izenda-UserProfile'>
          <MyProfileToolbar store={store} />
          <div className='izenda-Wrapper-content'>
            <ScrollBox>
              <div className='u_paddingLeftRight'>
                <GridLayout className='u_paddingAll u-bgWhite'>
                  <MyPreferenceId store={store} />
                  <MyPreferenceFirstName store={store} />
                  <MyPreferenceLastName store={store} />
                  <MyPreferenceEmail store={store} />
                  <MyPreferenceRole store={store} />
                  <MyPreferenceTimeZone store={store} />
                  <MyPreferenceLanguageInfo store={store} />
                </GridLayout>
              </div>
            </ScrollBox>
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(MyPreference);
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreference.jsx